export type ProfitabilityFilterValue = string | boolean;

export type State = {
  mercado: string;
  search: string;
  ativo_lastro: string;
  metodo: string;
  tipo_devedor: string;
  pulverizacao: ProfitabilityFilterValue;
  classificacao_risco: string;
};

export const DEFAULT_PROFITABILITY_MARKET = 'CRI';
export const DEFAULT_PROFITABILITY_METHOD = 'IPCA';
export const INITIAL_PROFITABILITY_STATE: State = {
  mercado: DEFAULT_PROFITABILITY_MARKET,
  search: '',
  ativo_lastro: '',
  metodo: DEFAULT_PROFITABILITY_METHOD,
  tipo_devedor: '',
  pulverizacao: '',
  classificacao_risco: '',
};

export type FilterOption<T = ProfitabilityFilterValue> = {
  code: string;
  label: string;
  value: T;
};

export type ProfitabilityFilter = {
  [key: string]: {
    code: string;
    label: string;
    options: FilterOption[];
  };
};

export type Profitability = {
  id: number;
  csci: string;
  operacao: string;
  operacao_id: string;
  titulo_id: string;
  classe: string;
  emissao: string;
  serie: number;
  data_emissao: Date;
  montante_emitido: number;
  prazo: number;
  ativo_lastro: string;
  tipo_devedor: string;
  agente_fiduciario: string;
  tipo_oferta: string;
  regime_fiduciario: boolean;
  pulverizacao: boolean;
  quantidade_emitida: number;
  isin: string;
  classificacao_risco: string;
  benchmark: string;
  codigo: string;
  data: Date;
  duration: number;
  mercado: string;
  preco_unitario: number;
  preco_unitario_acrescido_juros: number;
  preco: number;
  taxa: number;
  metodo: string;
  data_processamento: Date;
  ano_referencia: number;
};
